<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div class="flex flex-col h-full gap-3">
    <div class="item-chron-summary qb-primary-tint shrink-0">
      <div class="item-chron-summary__field">
        <div class="item-chron-summary__label">Item</div>
        <div class="item-chron-summary__value item-chron-summary__value--mono">{{ itemDetail?.id }}</div>
      </div>
      <div class="item-chron-summary__divider"></div>
      <div class="item-chron-summary__field">
        <div class="item-chron-summary__label">Manufacturer</div>
        <div class="item-chron-summary__value">{{ manufacturerName || "—" }}</div>
      </div>
      <div class="item-chron-summary__divider"></div>
      <div class="item-chron-summary__field">
        <div class="item-chron-summary__label">Style</div>
        <div class="item-chron-summary__value">{{ style || "—" }}</div>
      </div>
      <div class="item-chron-summary__divider"></div>
      <div class="item-chron-summary__field item-chron-summary__field--description">
        <div class="item-chron-summary__label">Description</div>
        <div class="item-chron-summary__value">{{ description || "—" }}</div>
      </div>
      <div class="item-chron-summary__divider"></div>
      <div class="item-chron-summary__field">
        <div class="item-chron-summary__label">Ownership</div>
        <div class="item-chron-summary__value">{{ ownership }}</div>
      </div>
      <div class="item-chron-summary__spacer"></div>
    </div>

    <p-tabView class="uni-tabview flex-1 min-h-0" styleClass="h-full">
      <p-tabPanel header="Story">
        <uni-item-story class="block h-full" [itemDetailId]="itemDetail?.id"></uni-item-story>
      </p-tabPanel>
      <p-tabPanel header="Raw Log">
        <uni-item-detail-log-grid class="block h-full" [itemDetailId]="itemDetail?.id"></uni-item-detail-log-grid>
      </p-tabPanel>
    </p-tabView>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2 mt-3">
    <button pButton type="button" class="p-button-raised" (click)="close()">Close</button>
  </div>
</ng-template>
